import React from 'react'
import { FaBriefcaseMedical } from 'react-icons/fa'

import "../../Pages/homepage.css"
export const WhyCard = ({img ,label}) => {
    return (
      <div className='rs-why-flex'>
    <div className='rs-why'>
              <div style={{ width:'80px',height:'100px',margin:'auto', color:'#09a09d',marginTop:'4%'}}>
                  <img src={img} alt="" w='100%' height="100%"/>
                </div>
                <div className='rs-s'></div>
      </div>
            <h1 className='rs-video-subhead'>{label}</h1>
     </div>
  )
}